import { Dispatch, SetStateAction } from 'react';
import { useQuery } from 'react-query';

import {
  applicationQuestionsKey,
  errorMessage,
  getJobPostingsQuestionsRoute,
} from '@features/applicationQuestions';
import axiosInstance from '@server/axiosInstance';

type UseGetApplicationQuestionsProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useGetApplicationQuestions = ({
  setErrorText = () => {},
}: UseGetApplicationQuestionsProps) => {
  const {
    data: applicationsQuestionData,
    isLoading: isLoadingApplicationQuestionsData,
  } = useQuery({
    queryKey: [applicationQuestionsKey],
    queryFn: () =>
      axiosInstance.get(getJobPostingsQuestionsRoute).then((res) => res.data),
    onSuccess: (data) => {
      if (data.status !== 200) {
        setErrorText(data?.message ?? errorMessage);
      } else {
        setErrorText('');
      }
    },
    onError: () => setErrorText(errorMessage),
  });

  return {
    applicationsQuestionData,
    isLoadingApplicationQuestionsData,
  };
};
